import Toastr from './Toastr'
import { closeToast } from '../../store/modules/toastr'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  toasts: state.toastr.toasts,
})

const mapDispatchToProps = dispatch => ({
  close: id => () => dispatch(closeToast(id)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Toastr)
